import React, {useState, useEffect} from 'react'
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import './ParentUserForm.css';

// import { INITIAL_VALUES_ADD_ADMIN, VALIDATION_SCHEMA_ADD_ADMIN } from './utils';
import AlertModal from 'web/components/AlertModal';
import HOCButton from 'web/components/Button';
import TextInput from 'web/components/form-elements/TextInput';
import PhoneNumber from "web/components/form-elements/PhoneNumber";
import NumberInput from 'web/components/form-elements/NumberInput';
import { Form, Formik } from 'formik';
import { SelectWrapper } from './../../DashBoard/dashBoardStyled.js';
import Select from 'react-select';
import { ptPlusAddParentUserAPI, ptPlusUpdateParentUserAPI, checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { storeAdminDetails, logoutAdmin } from "redux/actions/admin";
import { ptPlusBuyBackMainLocationList, } from "redux/actions/adminPTPlusBuyBackFee";
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { sortListOfObjects } from 'helpers'

const ParentUserForm = (props) => {
    let history = useHistory()
    const dispatch = useDispatch();

    const [zipCodeError, setZipCodeError] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [locationC, setLocationC] = useState([]);

    const getMainLocationOptions = async () => {
        try {
            let response = await dispatch(ptPlusBuyBackMainLocationList());
            if (response && response?.success && response?.data && response?.data?.mainLocations) {
                const locationOptions = response?.data?.mainLocations?.map(location => ({
                    label: `${location.locationName}, ${location.city}, ${stateConvert(location.state) || location.state}, ${location.zipCode}`,
                    value: location.locationId,
                    locationName: location.locationName // added for sorting
                }));
                const sortedLocationOptions = sortListOfObjects("string", locationOptions, "asc", "locationName") // sort alphabetically
                setLocationOptions(sortedLocationOptions);
                setLocationC(response?.data?.mainLocations);
            } else {
                setLocationOptions([]);
            }
        } catch (error) {
            setLocationOptions([]);
        }
    };

    // function addParentUser(values) {
    const addParentUser = async (formData) => {
        // e.preventDefault();
        let requestData = {...formData};
        
        requestData.assignedMainLocations = formData.assignedMainLocations.map(location => {
            const locationsDetails = locationC
                .find(locDetails => locDetails.locationId === location.value);
            
            return {
                locationName: locationsDetails.locationName,
                cityStateZip: `${locationsDetails.city}, ${locationsDetails.state} ${locationsDetails.zipCode}`,
                locationId: locationsDetails.locationId,
            };
        });

        const token = localStorage.getItem('token');
        let response = await dispatch(ptPlusAddParentUserAPI(requestData, token))
        if (response.success) {
            props.fetchCollection();
            props.setModal(false);
            props.setAlertModalContent('Parent customer created successfully.')
            props.setAlertModal(!props.alertModal)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                const errorMessage = response?.data?.error?.message
                    || response?.data?.message
                    || response?.message
                    || 'Something went wrong, please try again in some time.'
                props.setAlertModalContent(errorMessage)
                props.setAlertModal(!props.alertModal)
            }
        }
    } 

    const updateParentUser = async (formData) => {
        // e.preventDefault();
        // console.log('##addParentUser 1');
        let requestData = {...formData};

        //Remove fields before update API call
        delete requestData.emailId;
        delete requestData.locationName;
        delete requestData.street;
        delete requestData.city;
        delete requestData.state;
        delete requestData.zipCode;
        delete requestData.contactNumber;

        requestData.assignedMainLocations = formData.assignedMainLocations.map(location => {
            const locationsDetails = locationC
                .find(locDetails => locDetails.locationId === location.value);
            
            return {
                locationName: locationsDetails.locationName,
                cityStateZip: `${locationsDetails.city}, ${locationsDetails.state} ${locationsDetails.zipCode}`,
                locationId: locationsDetails.locationId,
            };
        });

        const token = localStorage.getItem('token');
        let response = await dispatch(ptPlusUpdateParentUserAPI(requestData, token))
        if (response.success) {
            props.fetchCollection();
            props.setModal(false);
            props.setAlertModalContent('Parent customer updated successfully.')
            props.setAlertModal(!props.alertModal)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                const errorMessage = response?.data?.error?.message
                    || response?.data?.message
                    || response?.message
                    || 'Something went wrong, please try again in some time.'
                props.setAlertModalContent(errorMessage)
                props.setAlertModal(!props.alertModal)
            }
        }

        // console.log('##addParentUser 2');
    } 

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        
        localStorage.clear();
        
        history.push('./sign-in')
        window.location.reload(false);
    }

    const zipCodeFunction = async (value, setFieldValue) => {
        setZipCodeError(false);

        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value))
            if (response.success) {
                setFieldValue('zipCode', response?.data?.zipCode)
                setFieldValue('state', response?.data?.state)
                setFieldValue('city', response?.data?.city)
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    setFieldValue('state', '');
                    setFieldValue('city', '');

                    setZipCodeError(true)
                } else if (response.error?.message === 'Invalid token'
                    || response.message === 'Request failed with status code 401'
                ) {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {

                }
            }
        } else {
            setFieldValue('state', '');
            setFieldValue('city', '');
        }
    }

    useEffect(() => {
        getMainLocationOptions();
    }, []);

    return <div className='parent-user-form'>
        <Formik
            initialValues={ props.formType === 'edit'
                ? {
                    id: props?.formData?.id,
                    emailId: props?.formData?.emailAddress,
                    locationName: props?.formData?.locationName,
                    street: props?.formData?.street,
                    city: props?.formData?.city,
                    state: props?.formData?.state,
                    zipCode: props?.formData?.zip,
                    contactNumber: props?.formData?.contactNumber,
                    assignedMainLocations: props?.formData?.assignedLocations
                    .map(loc => {
                        const label =
                            `${loc.locationName}
                            ${loc?.city ?  ', '+loc.city : ''}
                            ${loc?.state ? ', '+loc.state : ''}
                            ${loc?.zip ? ', '+loc.zip : ''}
                            `;
                        return {
                            // label: loc.locationName,
                            label,
                            value: loc.locationId,
                        }
                    }),
                    active: props?.formData?.active,
                }
                : INITIAL_VALUES_ADD_PARENT_USER
            }
            validationSchema={VALIDATION_SCHEMA_ADD_PARENT_USER}
            onSubmit={(values) => {
                console.log(values);
            }}
        >
            {({isValid, dirty, values, setFieldValue}) => {
                return <Form>
                    <div className='primary-details'>
                        {/*<div className='header'>
                            Primary Details
                        </div>*/}
                        <div className='first-row'>
                            <div className='location-name'>
                                <p className='label'>
                                    Location Name
                                    <span className='star'>*</span>
                                </p>
                                <div className='puf-input-text'>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='locationName'
                                            showErrorMessages={true}
                                            
                                            disabled={props.formType === 'edit'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='email'>
                                <p className='label'>
                                    Email
                                    <span className='star'>*</span>
                                </p>
                                <div className='puf-input-text'>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='emailId'
                                            showErrorMessages={true}
                                            
                                            maxLength={100}
                                            disabled={props.formType === 'edit'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='second-row'>
                        {/*<div className='header'>
                            Address Details
                        </div>*/}
                        <div className='contact-number'>
                            <p className='label'>
                                Phone Number
                                <span className='star'>*</span>
                            </p>
                            <PhoneNumber
                                name="contactNumber"

                                disabled={props.formType === 'edit'}
                            />
                        </div>
                        <div className='street'>
                            <p className='label'>
                                Address
                                <span className='star'>*</span>
                            </p>
                            <div className='puf-input-text'>
                                    <TextInput
                                        name='street'
                                        showErrorMessages={true}

                                        disabled={props.formType === 'edit'}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className='third-row'>
                        <div className='city'>
                            <p className='label'>
                                City
                                <span className='star'>*</span>
                            </p>
                            <div className='puf-input-text'>
                                    <TextInput
                                        name='city'
                                        showErrorMessages={true}

                                        disabled={props.formType === 'edit'}
                                    />
                            </div>
                        </div>
                        <div className='state'>
                            <p className='label'>
                                State
                                <span className='star'>*</span>
                            </p>
                            <div className='puf-input-text'>
                                <div style={{ width: '100%' }}>
                                    <TextInput
                                        name='state'
                                        showErrorMessages={true}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='zip-code'>
                            <p className='label'>
                                Zip Code
                                <span className='star'>*</span>
                            </p>
                            <div className='puf-input-text'>
                                <div style={{ width: '100%' }}>
                                    {/*
                                    <TextInput
                                        name='zipCode'
                                        showErrorMessages={true}
                                    />*/}
                                    <NumberInput
                                        name="zipCode"
                                        maxLength="5"
                                        showErrorMessages={true}
                                        onChangeHandler={(value) => {
                                            zipCodeFunction(value, setFieldValue)
                                        }} 

                                        disabled={props.formType === 'edit'}
                                    />
                                </div>
                            </div>
                            {zipCodeError && <h6
                                style={{
                                    marginTop: '-15px',
                                    fontSize: '12px',
                                    color: '#ef5657'
                                }}>
                                Invalid Zip Code
                            </h6>}
                        </div>
                    </div>
                    <div className='locations-details'>
                        <p className='label'>
                            Assigned Locations
                            <span className='star'>*</span>
                        </p>
                        <div className='puf-input-text'>
                            <div style={{ width: '100%' }}>
                                <SelectWrapper>
                                    <Select
                                        name='assignedMainLocations'
                                        value={values.assignedMainLocations}
                                        isMulti
                                        options={locationOptions}
                                        onChange={value => {
                                            if (value !== null) {
                                                setFieldValue('assignedMainLocations', value)
                                            } else {
                                                setFieldValue('assignedMainLocations', [])
                                            }
                                        }}
                                    />
                                </SelectWrapper>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: '15px', textAlign: '-webkit-center' }}>
                        <HOCButton
                            type='app-green-button submitBtn'
                            handleClick={() => {
                                if (props.formType === 'edit') {
                                    updateParentUser(values);
                                } else if (props.formType === 'create') {
                                    addParentUser(values);
                                }
                            }}
                            disabled={!(isValid && dirty)}
                        >
                            {props.formType === 'edit'
                                ? 'Update Parent Customer'
                                : 'Create Parent Customer'
                            }
                        </HOCButton>
                    </div>
                </Form>
            }}
        </Formik>
    </div>
}

// Schemas
const INITIAL_VALUES_ADD_PARENT_USER = {
    emailId: '',
    locationName: '',
    street: '',
    city: '',
    state: '',
    zipCode: '',
    contactNumber: '',
    assignedMainLocations: [ ],
    // emailId: 'pauljoy06+5@gmail.com',
    // locationName: 'Pallet Brokers',
    // street: 'Main Road',
    // city: 'Banglore',
    // state: 'Karnataka',
    // zipCode: '56006',
    // contactNumber: '123-456-7890',
    // assignedMainLocations: [ ],
};

const VALIDATION_SCHEMA_ADD_PARENT_USER = Yup.object().shape({
    emailId: Yup.string().required('Email is required').email('Please enter a valid email'),
    locationName: Yup.string().required('Location Name is required'),
    street: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('Enter state name'),
    zipCode: Yup.string().required('Zip is required'),
    contactNumber: Yup.string()
        .required('Phone number is required')
        .matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
    assignedMainLocations: Yup.array()
        .min(1, 'Pick at least 1 main location'),
        // .of(
        //     Yup.object().shape({
        //         label: Yup.string().required(),
        //         value: Yup.string().required(),
        //     })
        // )
});


export default ParentUserForm;
